const baseUrl = '/admin/lobbies'

type TLobbyListQueryParams = {
  page?: number
  per_page?: number
  q?: string
}

export const lobbyEndpoints = {
  root: () => baseUrl,
  list: (query?: TLobbyListQueryParams) => {
    const params = new URLSearchParams()
    if (query?.page) params.append('page', String(query.page))
    if (query?.per_page) params.append('per_page', String(query.per_page))
    if (query?.q) params.append('q', query.q)

    const queryString = params.toString()
    return queryString ? `${baseUrl}?${queryString}` : baseUrl
  },
  detail: (lobbyId: string) => `${baseUrl}/${lobbyId}`,
}
